<template>
    <div :class="menuClass">
        <template v-for="menu in menuItems">
            <div :class="menuItemClass(menu)" @click="clickMenu(menu)">
                <span>{{menu.text}}</span>
                <ur-icon-wrapper v-if="hasChild(menu)" class="fold-icon">
                    <ur-icon type="line">collapse_menu</ur-icon>
                </ur-icon-wrapper>
            </div>
            <aicc-lnb-menu v-if="hasChild(menu)" :menuItems="menu.children" :depth="depth+1"/>
        </template>
    </div>
</template>
<script>
export default {
    name: 'aicc-lnb-menu',
    props:{
        depth: {
            type: Number,
            default: 1,
        },
        menuItems: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {}
    },
    created(){},
    mounted(){},
    inject: ['side'],
    computed:{
        menuClass() {
            return [
                'ur-lnb__menu-list',
                'ur-lnb__menu-list--depth-'+this.depth,
            ];
        },
        menuItemClass() {
            return(menu) => {
                let clazz = [];
                let foldable = this.hasChild(menu);
                let selected = (menu === this.side.currMenu);

                clazz.push('ur-lnb__menu');
                if(selected) {
                    clazz.push('ur-lnb__menu--selected');
                }
                if(foldable) {
                    clazz.push('ur-lnb__menu-foldable');
                }
                if(menu.folderYn == 'Y') {
                    clazz.push('ur-lnb__menu--fold');
                }
                return clazz;
            };
        }
    },
    watch:{},
    methods:{
        hasChild(menu) {
            return (menu.children && menu.children.length > 0) ? true : false;
        },
        clickMenu(menuItem) {
            if(this.hasChild(menuItem)) {
                if(menuItem.folderYn == 'Y') {
                    menuItem.folderYn = 'N';
                } else {
                    menuItem.folderYn = 'Y';
                }
                this.$forceUpdate();
            }
            this.side.clickMenu(menuItem);
        }
    },
}
</script>
<style scoped>
    .fold-icon {
        display: inline-block;
    }
    .ur-lnb__menu {
        border-radius: 4px;
        height: 40px;
        line-height: 40px;
        font-weight: 500;
    }
    .ur-lnb__menu--selected {
        font-weight: 700;
    }
    .ur-lnb__menu:hover {
        font-weight: 700;
    }
    .ur-lnb__menu-list--depth-2 > .ur-lnb__menu {
        margin-left:32px;
        padding-left:16px;
    }
</style>